/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Turnstilerequired1Inputs */

const he_contact_turnstilerequired1 = /** @type {(inputs: Contact_Turnstilerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נא להשלים את אימות האבטחה`)
};

const en_contact_turnstilerequired1 = /** @type {(inputs: Contact_Turnstilerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please complete the security verification`)
};

/**
* | output |
* | --- |
* | "Please complete the security verification" |
*
* @param {Contact_Turnstilerequired1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_turnstilerequired1 = /** @type {((inputs?: Contact_Turnstilerequired1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Turnstilerequired1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_turnstilerequired1(inputs)
	return en_contact_turnstilerequired1(inputs)
});
export { contact_turnstilerequired1 as "contact_turnstileRequired" }